import { createApp, ref } from 'vue'
import router from './router';
import store from './store';
import App from './App.vue';

const app = createApp(App);

let CurrentUserID = ref(null);
let IsSharePoint = ref(false);

function SetDateFormat(value)
{
    if (!value) return '';
    const date = new Date(value);
    return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
}

function SetToken(token)
{
    localStorage.setItem('session_token', token);
}

function SetUserID(uid)
{
    localStorage.setItem('user_id', uid);
    CurrentUserID.value = uid;
}

function SetUsername(username)
{
    localStorage.setItem('username', username);
}

function GetUserID()
{
    return localStorage.getItem('user_id');
}

function GetUsername()
{
    return localStorage.getItem('username');
}

function GetToken()
{
    return localStorage.getItem('session_token');
}

function ClearSessionInfo()
{
    localStorage.removeItem('session_token');
    localStorage.removeItem('user_id');
    localStorage.removeItem('username');
    CurrentUserID.value = null;
}

function HandleBadRequest(status, data)
{
    if (status == 401)
    {
        if (data == 1)
        {
            ClearSessionInfo();
            const router = app.config.globalProperties.$router;
            router.push('/');
        }
    }
}

function FormatCurrency(number, numberCurrency = '¥')
{
    const cult = numberCurrency === '$' ? 'us-US' : 'ja-JP';
    const curr = numberCurrency === '$' ? 'USD' : 'JPY';

    if (number === null ||
        number === undefined)
    {
        return new Intl.NumberFormat(cult, { style: 'currency', currency: curr, currencyDisplay: 'narrowSymbol' }).format(0);
    }

    return new Intl.NumberFormat(cult, { style: 'currency', currency: curr, currencyDisplay: 'narrowSymbol' }).format(number);
}

function FormatNumber(number)
{
    if (number === null ||
        number === undefined)
    {
        return 0;
    }

    return new Intl.NumberFormat('ja-JP').format(number,);
}

function FormatDateForServer(date)
{
    return date.format(`YYYY-MM-DD ${process.env.VUE_APP_TIMEZONE_ADD_HOURS}:mm:ss`);
}

app.config.globalProperties.$SetDateFormat = SetDateFormat;
app.config.globalProperties.$HandleBadRequest = HandleBadRequest;
app.config.globalProperties.$FormatCurrency = FormatCurrency;
app.config.globalProperties.$FormatNumber = FormatNumber;
app.config.globalProperties.$SetToken = SetToken;
app.config.globalProperties.$GetToken = GetToken;
app.config.globalProperties.$SetUserID = SetUserID;
app.config.globalProperties.$SetUsername = SetUsername;
app.config.globalProperties.$GetUserID = GetUserID;
app.config.globalProperties.$GetUsername = GetUsername;
app.config.globalProperties.$ClearSessionInfo = ClearSessionInfo;
app.config.globalProperties.$FormatDateForServer = FormatDateForServer;

app.config.globalProperties.$CurrentUserID = CurrentUserID;
app.config.globalProperties.$IsSharePoint = IsSharePoint;

app.use(router).use(store).mount('#app');